export default {
    TITLE_REMOVE_DATA: '数据删除提示',
    TITLE_SAVE_DATA: '数据保存提示',
    TITLE_COPY_DATA: '数据复制提示',
    TITLE_UPLOAD_DATA: '数据上传提示',
    TITLE_PUBLISH_DATA: '数据发布提示',
    TITLE_PAUSE_DATA: '数据暂停提示',
    TITLE_RESTORE_DATA: '数据恢复提示',
    TITLE_SUBMIT_DATA: '数据提交提示',

    HINT_SAVE_SUCCESS: '数据已保存成功',
    HINT_COPY_SUCCESS: '数据已复制成功',
    HINT_UPLOAD_SUCCESS: '数据已上传成功',
    HINT_UPLOAD_ERROR: '数据上传失败',
    HINT_REMOVE_SUCCESS: '数据已删除成功',
    HINT_PUBLISH_SUCCESS: '数据已发布成功',
    HINT_PAUSE_SUCCESS: '数据已暂停成功',
    HINT_RESTORE_SUCCESS: '数据已恢复成功',
    
    HINT_NO_DATA_SELECTED:'请选择需要删除的数据',

    CONFIRM_CONTENT_REMOVE_DATA:'确定要删除当前记录吗？',

    WARN_SUBMIT: '请先保存，然后再提交',

    LOADING_TEXT_LOADDATA: '加载数据中，请稍等...',
    LOADING_TEXT_DELETEDATA: '删除数据中，请稍等...',
    LOADING_TEXT_MODIFYDATA: '修改数据中，请稍等...',
    LOADING_TEXT_SAVEDATA: '保存数据中，请稍等...',
}